import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllSizes = (filters = {}) => {
  return new Promise((resolve, reject) => {
    const query_string = new URLSearchParams(filters).toString();
    
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/size?${query_string}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const fetchOneSize = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/size/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createSize = (data) => {
  return new Promise((resolve, reject) => {
    if (!data) return resolve(null);

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/size/`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateSize = ({ id, data }) => {
  return new Promise((resolve, reject) => {
    if (!id || !data) return resolve(null);

    axios
      .put(`${process.env.REACT_APP_BASE_URL}/size/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteSize = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/size/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
